<script lang="ts">
	import { page } from '$app/stores';
	$: currentRoute = $page.route.id;
</script>

<header id="header" class:alt={currentRoute === '/'}>
	<h1>
		<a href="/"
			><img class="word-mark" src="/images/word-mark.webp" alt="King Can Cleaning logo" /></a
		>
	</h1>
	<nav id="nav">
		<ul>
			<li><a href="/" class:active={currentRoute === '/'}>Home</a></li>
			<li><a href="/about" class:active={currentRoute === '/about'}>About</a></li>
			<li><a href="/services" class:active={currentRoute === '/services'}>Services</a></li>
			<li><a href="/pricing" class:active={currentRoute === '/pricing'}>Pricing</a></li>
			<li><a href="/contact">Contact Us</a></li>
		</ul>
	</nav>
</header>

<style lang="scss">
	.word-mark {
		height: 3.2rem;
		margin: 0;
		padding: 5px 0px 0px 0px;

		@media (max-width: 1280px) {
			height: 3rem;
		}

		@media (max-width: 1024px) {
			height: 2.8rem;
		}

		@media (max-width: 736px) {
			height: 2.5rem;
		}

		@media (max-width: 480px) {
			height: 2rem;
		}
	}
</style>
